import { gql } from '@apollo/client';

export const CREATE_TOKEN_LOCATION = gql`
  mutation CreateTokenLocation($portfolioId: ID!, $name: String!) {
    createTokenLocation(portfolioId: $portfolioId, name: $name)
  }
`;

export const RENAME_TOKEN_LOCATION = gql`
  mutation RenameTokenLocation($portfolioId: ID!, $locationId: ID!, $name: String!) {
    renameTokenLocation(portfolioId: $portfolioId, locationId: $locationId, name: $name)
  }
`;

export const DELETE_TOKEN_LOCATION = gql`
  mutation DeleteTokenLocation($portfolioId: ID!, $locationId: ID!) {
    deleteTokenLocation(portfolioId: $portfolioId, locationId: $locationId)
  }
`;
